import { CallStats, StatsCommon } from '#common/stats';
export class FilePermissionsStats extends StatsCommon {
    grantAccess;
    revokeAccess;
    listAccess;
    listAccessIterator;
    listAccessPartialFrom;
    listAccessPaginated;
    getPrincipalsAccess;
    constructor(log) {
        super();
        this.grantAccess = new CallStats('grantAccess', log);
        this.revokeAccess = new CallStats('revokeAccess', log);
        this.listAccess = new CallStats('listAccess', log);
        this.listAccessIterator = new CallStats('listAccessIterator', log);
        this.listAccessPartialFrom = new CallStats('listAccessPartialFrom', log);
        this.listAccessPaginated = new CallStats('listAccessPaginated', log);
        this.getPrincipalsAccess = new CallStats('getPrincipalsAccess', log);
    }
}
